import { getUseTHEOplayerV2FromLocalStorage } from "../enableTheoPlayerV2";
import { isNewVideoPlayerImportEnabled } from "../theoPlayer/newVideoPlayerImportFlag";

import type * as THEOplayerType from "theoplayer";

/*
  THEOplayerLegacyRuntimeの型ファイルには `export declare namespace videojs` の定義がある。
  ただし、module exportとしては扱われないため、importした型では`videojs`を直接参照できない。
  そのため、THEOplayerRuntimeとTHEOplayerLegacyRuntimeの両方で`videojs`が存在する前提を満たすために、独自の型を定義している。
*/
export type THEOPlayerRuntime = typeof THEOplayerType & {
  videojs: typeof THEOplayerType.videojs;
};

export type ResolvedTHEOPlayerRuntime = {
  THEOplayer: THEOPlayerRuntime;
  libraryLocation: string;
};

type TheoPlayerImportSource = "node-module" | "cdn-window";

export const getTheoPlayerImportSource = (): TheoPlayerImportSource => {
  return isNewVideoPlayerImportEnabled() ? "node-module" : "cdn-window";
};

export const getTHEOplayerRuntimeWithLibraryLocation = async (): Promise<{
  THEOplayer: THEOPlayerRuntime;
  libraryLocation: string;
}> => {
  const shouldUseLegacyRuntime = getUseTHEOplayerV2FromLocalStorage();

  if (shouldUseLegacyRuntime) {
    const legacyRuntime =
      (await import("theoplayer-legacy")) as unknown as THEOPlayerRuntime;
    if (legacyRuntime.videojs) {
      return {
        THEOplayer: legacyRuntime,
        libraryLocation: "/vendor/theoplayer-legacy/",
      };
    }
  }

  const runtime = await import("theoplayer");
  if (runtime.videojs) {
    return {
      THEOplayer: runtime,
      libraryLocation: "/vendor/theoplayer/",
    };
  }

  const legacyRuntime =
    (await import("theoplayer-legacy")) as unknown as THEOPlayerRuntime;
  if (legacyRuntime.videojs) {
    console.warn(
      "THEOplayer v8ランタイム取得に失敗したため、legacyランタイムにフォールバックします"
    );
    return {
      THEOplayer: legacyRuntime,
      libraryLocation: "/vendor/theoplayer-legacy/",
    };
  }

  console.error("THEOplayer runtimeを取得できません");
  throw new Error("THEOplayer runtimeがロードされていません");
};
